import script from "./UploadPdf.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadPdf.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__